export default window.config || {
    aesirUrl: process.env.VUE_APP_AESIR_URL,
    appLanguage: process.env.VUE_APP_LANGUAGE,
    customVideoLogIntervalEndTime: process.env.VUE_APP_CUSTOM_VIDEOLOG_INTERVAL_END_TIME,
    chatTokenTimeout: process.env.VUE_APP_CHAT_JWT_TIMEOUT,
    customVideoLogIntervalMilliseconds: process.env.VUE_APP_CUSTOM_VIDEOLOG_INTERVAL_MILLISECONDS,
    customVideoLogIntervalStartTime: process.env.VUE_APP_CUSTOM_VIDEOLOG_INTERVAL_START_TIME,
    digitalClassRoomBufferTime: process.env.VUE_APP_DIGITAL_CLASSROOM_BUFFER,
    eduhouseSSOEnabled: process.env.VUE_APP_EDUHOUSE_SSO_ENABLED,
    februaryDigitalClassroomsUpdateBannerEndDate: process.env.VUE_APP_FEBRUARY_23_DIGITAL_CLASSROOMS_UPDATES_BANNER_END_DATE,
    hubSpotCookieBlockerId: process.env.VUE_APP_HUBSPOT_COOKIE_BLOCKER_ID,
    hubSpotNewsletterFormId: process.env.VUE_APP_HUBSPOT_NEWSLETTER_FORM_ID,
    hubSpotPortalId: process.env.VUE_APP_HUBSPOT_PORTAL_ID,
    mimirUrl: process.env.VUE_APP_MIMIR_URL,
    percentageVideoRequire: process.env.VUE_APP_PERCENTAGE_VIDEO_REQUIRE,
    summitEnd: process.env.VUE_APP_SUMMIT_END,
    summitStart: process.env.VUE_APP_SUMMIT_START,
    taxationDayFinlandStart: process.env.VUE_APP_TAXATION_DAY_FINLAND_START,
    taxationDaySwedenEnd: process.env.VUE_APP_TAXATION_DAY_SWEDEN_END,
    taxationDaySwedenStart: process.env.VUE_APP_TAXATION_DAY_SWEDEN_START,
    useMimirForChat: process.env.VUE_APP_USE_MIMIR_FOR_CHAT,
    showEvaAdminPopupMOdalStart: process.env.VUE_APP_SHOW_EVA_ADMIN_POPUP_MODAL_START,
    showEvaAdminPopupMOdalEnd: process.env.VUE_APP_SHOW_EVA_ADMIN_POPUP_MODAL_END
}
